export default __webpack_public_path__ + "static/vehicles-8337e5325ff54a1e9c514232a81d100a.png";